import { appReducer, initialAppState } from './app.reducer.js';
import type { AppEvent, AppState } from './app.types.js';

export class AppStore {
  #state: AppState = initialAppState;
  readonly #listeners = new Set<() => void>();

  getSnapshot = (): AppState => this.#state;

  subscribe = (listener: () => void): (() => void) => {
    this.#listeners.add(listener);
    return () => this.#listeners.delete(listener);
  };

  dispatch(event: AppEvent): void {
    const nextState = appReducer(this.#state, event);
    if (nextState === this.#state) return;
    this.#state = nextState;
    for (const listener of this.#listeners) listener();
  }
}
